import { z } from 'zod';

export type TMeta = z.infer<typeof metaSchema>;

export const metaSchema = z
  .object({
    title: z.string().optional().nullable(),
    description: z.string().optional().nullable(),
  })
  .nullable()
  .optional();
